import { types as actionTypes } from './waiverAirlinesActions';
import { Action } from '../../../types';
import { WaiverAirline } from '../../../../types/waiver';

export type WaiverAirlinesState = {
  loading: boolean;
  entities?: WaiverAirline[];
  error?: string;
};

const initialState: WaiverAirlinesState = {
  loading: false,
};

export default function reducer(
  state: WaiverAirlinesState = initialState,
  action: Action<WaiverAirline[]>
): WaiverAirlinesState {
  switch (action.type) {
    case actionTypes.LOAD:
      return {
        loading: true,
      };
    case actionTypes.LOAD_SUCCESS:
      return {
        loading: false,
        entities: action.response,
      };
    case actionTypes.LOAD_FAILURE:
      return {
        loading: false,
        error: action.error ? action.error.message : undefined,
      };
    default:
      return state;
  }
}
